import React from "react"
import { Row, Col } from "reactstrap"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import "../../Reporting/datatables.scss"
import {
  dateFormatter,
  dateSorter,
  defaultPageSizeOptions,
  stringSorter,
} from "utils/general"
import { Table as AntdTable } from "antd"
import { tableDefaultHeight } from "constants/layout"

const HandoverMonitoringTable = props => {
  // Table structure
  const columns = [
    {
      dataIndex: "description",
      title: props.t("Alarm"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "description", sortOrder)
      },
      render: descriptionFormatter,
      width: "180px",
    },

    {
      dataIndex: "client",
      title: props.t("Customer"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "client", sortOrder)
      },
      width: "180px",
    },
    {
      dataIndex: "updated_at",
      title: props.t("Time"),
      defaultSortOrder: "descend",
      sorter: (a, b, sortOrder) => {
        return dateSorter(a["updated_at"], b["updated_at"], sortOrder)
      },
      render: dateFormatter,
      width: "180px",
    },
  ]

  function descriptionFormatter(cell, row) {
    //return props.t(value)
    if (row.status == "CLOSED") {
      return (
        <>
          <i
            style={{ verticalAlign: "bottom" }}
            className="bx bx-check-circle font-size-20 text-success me-2"
          />
          <span>{props.t(cell)}</span>
        </>
      )
    } else if (row.status == "ASSIGNED") {
      return (
        <>
          <i
            style={{ verticalAlign: "bottom" }}
            className="bx bxs-calendar-heart font-size-20 text-warning me-2"
          />
          <span>{props.t(cell)}</span>
        </>
      )
    } else {
      return (
        <>
          <i
            style={{ verticalAlign: "bottom" }}
            className="bx bxs-calendar-heart font-size-20 text-danger me-2"
          />
          <span>{props.t(cell)}</span>
        </>
      )
    }
  }

  return (
    <React.Fragment>
      <Row>
        <Col className="col-12">
          {props.alarms && (
            <React.Fragment>
              <Row>
                <Col xl="12">
                  <AntdTable
                    className="light-header-table table align-middle table-nowrap mb-0"
                    bordered={false}
                    size="small"
                    rowKey={"key"}
                    columns={columns}
                    dataSource={props.alarms}
                    pagination={{
                      showSizeChanger: true,
                      defaultPageSize: 50,
                      pageSizeOptions: defaultPageSizeOptions,
                    }}
                    tableLayout="auto"
                    scroll={{
                      x: "max-content",
                      y: tableDefaultHeight,
                    }}
                  />
                </Col>
              </Row>
            </React.Fragment>
          )}
        </Col>
      </Row>
    </React.Fragment>
  )
}

HandoverMonitoringTable.propTypes = {
  t: PropTypes.any,
  alarms: PropTypes.any,
}

export default withTranslation()(HandoverMonitoringTable)
